import { getAPIUrl } from '../helpers/App';

export const APIgetDownloads = (params) => (
  window.axios.get(getAPIUrl('/downloads'), { params })
    .then(response => (response))
);

export const APIgetDownload = downloadUuid => (
  window.axios.get(getAPIUrl(`/downloads/${downloadUuid}`))
    .then(response => (response))
);

export const APIgetDownloadDetails = downloadUuid => (
  window.axios.get(getAPIUrl(`/downloads/${downloadUuid}/details`))
    .then(response => (response))
);

export const APIgetDownloadsUsers = params => (
  window.axios.get(getAPIUrl('/downloads/users'), { params })
    .then(response => (response))
);

export const APIcreateDownload = params => (
  window.axios.post(getAPIUrl('/downloads'), params)
    .then(response => (response))
);

export const APIupdateDownload = ({ download }) => (
  window.axios.patch(getAPIUrl(`/downloads/${download.uuid}`), { download })
    .then(response => (response))
);

export const APIdeleteDownload = downloadUuid => (
  window.axios.delete(getAPIUrl(`/downloads/${downloadUuid}`))
    .then(response => (response))
);

export const APIgetDownloadSummary = ({
  collections,
  files,
  versions,
  shareUuid = null,
  pageId = null,
  requestUuid = null,
  fileCollectionMap = null,
}) => {
  if (shareUuid) {
    return window.axios.post(getAPIUrl(`/shares/${shareUuid}/download_summary`), {
      collections,
      files,
      versions,
    })
      .then(response => (response));
  }

  if (pageId) {
    return window.axios.post(getAPIUrl(`/pages/${pageId}/download_summary`), {
      collections,
      files,
      versions,
      file_collection_map: fileCollectionMap,
    })
      .then(response => (response));
  }

  return window.axios.post(getAPIUrl('/downloads/summary'), {
    collections,
    files,
    versions,
    request_uuid:
    requestUuid,
  })
    .then(response => (response));
};

export const APIgetDownloadRequest = downloadRequestUuid => (
  window.axios.get(getAPIUrl(`/download-requests/${downloadRequestUuid}`))
    .then(response => (response))
);

export const APIgetDownloadRequestFiles = (downloadRequestUuid, params) => (
  window.axios.get(getAPIUrl(`/download-requests/${downloadRequestUuid}/files`), { params })
    .then(response => (response))
);

export const APIcreateDownloadRequest = params => (
  window.axios.post(getAPIUrl('/download-requests'), params)
    .then(response => (response))
);

export const APIupdateDownloadRequest = ({ downloadRequest }) => (
  window.axios.patch(getAPIUrl(`/download-requests/${downloadRequest.uuid}`), { download_request: downloadRequest })
    .then(response => (response))
);

export const APIgetDownloadRequests = params => (
  window.axios.get(getAPIUrl('/download-requests'), { params })
    .then(response => (response))
);

export const APIdeleteDownloadRequest = downloadRequestUuid => (
  window.axios.delete(getAPIUrl(`/download-requests/${downloadRequestUuid}`))
    .then(response => (response))
);

export const APIremoveDownloadRequestFiles = (downloadRequestUuid, files) => (
  window.axios.patch(getAPIUrl(`/download-requests/${downloadRequestUuid}/remove_files`), { files })
    .then(response => (response))
);

export const APIgetDownloadRequestSummary = params => (
  window.axios.post(getAPIUrl('/download-requests/summary'), params)
    .then(response => (response))
);
